import { createFileRoute, redirect } from "@tanstack/react-router";
import { toast } from "react-toastify";

export const Route = createFileRoute("/app/caminhao/editar/$id")({
  params: {
    parse: (val) => {
      return {
        id: +val.id
      };
    }
  },
  beforeLoad(ctx) {
    const { id } = ctx.params;
    if (!id) {
      toast.error("Caminhão não encontrado.");
      throw redirect({
        to: "/app"
      });
    }
  },
  head: () => ({
    meta: [{ name: "title", content: "Editar Caminhão" }]
  })
});
